import {Injectable, Optional} from '@angular/core';
import {ActivatedRoute, NavigationEnd, Router} from "@angular/router";
import {filter, map} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class RouterService {

  constructor(private route: ActivatedRoute,
              private router: Router) { }

  isEntity(type: string, route: ActivatedRoute) {
    return (route.routeConfig.path || route.parent.routeConfig.path) === type;
  }

  outerChange(route: ActivatedRoute = this.route) {
    return this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      map((result) => {
        return this.isOuter(route.children);
      }
    ));
  }

  isOuter(children: any) {
    for (let child of children) {
      if (child.data.value.outer) return true;
      return this.isOuter(child.children);
    }

    return false;
  }

  getPath(path: any[], relative?: boolean, entity?: boolean) {
    let result = path.slice();

    if (!relative) return result;

    const isOuter = this.isOuter(this.route.children);

    if (!isOuter) {
      if (result[0] === '/') {
        result.splice(0, 1);
      }

      if (entity) {
        result.splice(0, 1);
      }
    }

    return result;
  }
}
